export const transformIsbn = (value: string) => {
  return value.replace(/^\[(.+)\]$/, "$1").replace(/-/g, "");
};

export const transformMultipleIsbn = (value: string[]) =>
  value.map(transformIsbn);
